module.exports = __webpack_public_path__ + "static/media/23.e75df71b.jpeg";